import http from 'plugins/axios';

export default {
  updateExchange(data) {
    return http.post({
      url: `/la/admin/exchange-coin/update`,
      data
    });
  },
  exchangeCoins() {
    return http.get({
      url: '/la/admin/exchange-coin/coins',
    });
  },
  exchangeCoinsList(data) {
    return http.get({
      url: '/la/admin/exchange-coin/list',
      data
    });
  },
  createExchange(data) {
    return http.post({
      url: '/la/admin/exchange-coin/add',
      data
    });
  },
};
